import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FormModalProps } from '../utils/Type';
import Spinner from 'react-bootstrap/Spinner';

export const FormModal: React.FC<FormModalProps> = ({
  show,
  onValidate,
  onAbort,
  size = 'lg',
  btnValidate = 'Enregistrer',
  btnCancel = 'Annuler',
  title,
  body,
  footer,
  backdrop = 'static',
  showFooter = true,
  isBusy = false,
  validateDisabled,
  abortDisabled,
  disableClose
}) => {
  const isValidateDisabled = validateDisabled ?? isBusy;
  const isAbortDisabled = abortDisabled ?? isBusy;
  const closeDisabled = disableClose ?? isBusy;

  return (
    <Modal
      show={show}
      onHide={onAbort}
      size={size || "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={backdrop || "static"}
      keyboard={!closeDisabled}
      btnValidate={btnValidate}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
      {showFooter && (
        <Modal.Footer>
          {footer || (
            <>
              <Button
                variant="secondary"
                onClick={onAbort}
                disabled={isAbortDisabled}
                type="button"
              >
                {btnCancel}
              </Button>

              <Button
                onClick={onValidate}
                disabled={isValidateDisabled}
                type="button"
              >
                {isBusy && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                )}
                {btnValidate}
              </Button>
            </>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};